import { getRequestBody } from '../utilities/getRequestBody';
import jwt_decode from 'jwt-decode';

export interface IToUTokenHint {
    preferred_username?: string,
};

export const useGetPreferredUsername = () => {
    const { idTokenHint } = getRequestBody();
    const token = idTokenHint;

    if(token){
        const decodedToken: IToUTokenHint | undefined = jwt_decode(token);
        return decodedToken && decodedToken.preferred_username || '';
    }
    return '';
};